import React from 'react';
import { twMerge } from 'tailwind-merge';

import AudioStockItemCard from '../../app/Search/components/card/AudioStockItemCard';
import {
  StockItemContext,
  StockItemDetails,
} from '../../common/types/StockItemTypes';

interface MusicRecommendationListProps {
  title?: string;
  className?: string;
  stockItems: StockItemDetails[];
}

const MusicRecommendationList = ({
  className = '',
  title = 'Recommended Music for this Clip',
  stockItems = [],
}: MusicRecommendationListProps) => {
  if (!stockItems.length) {
    return null;
  }

  return (
    <div className={twMerge('flex flex-col', className)}>
      <h2 className="text-lg font-bold m-0 leading-6 text-gray-900">{title}</h2>
      <div className="flex flex-col space-y-2 ">
        {stockItems.map((item, index) => {
          return (
            <div key={index}>
              <AudioStockItemCard
                stockItem={item.stockItem}
                stockItemFormats={item.stockItemFormats}
                stockItemArtists={item.stockItemArtists}
                shouldShowDownloadButton={true}
                shouldShowAddToFavorites={true}
                context={StockItemContext.CROSS_ASSET_COLLECTION}
                isMobile={true}
                topTags={item.topTags}
                topSectionDivClassNames={'p-0'}
                bottomSectionDivClassNames={'pt-0 pb-1 h-8'}
                audioPlayerHeaderClassName={'text-xs pr-1 line-clamp-2'}
                metaDataClassNames={'mt-1 leading-2'}
                artistClassNames={'text-xs'}
                tagClassNames={'text-xs pr-1'}
                classNames={[
                  'shadow-none border rounded-lg border-solid border-gray-300',
                ]}
                isForCrossAssetMusicRecommendation={true}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MusicRecommendationList;
